document.addEventListener("DOMContentLoaded", function () {
        // ---------- 电费计算器逻辑 ----------
        const applianceSelect = document.getElementById("appliance");
        const customWattageGroup = document.getElementById("custom-wattage-group");
        const calculateBtn = document.getElementById("calculate-btn");
        const resultsDiv = document.getElementById("results");

        // 显示/隐藏自定义功率输入框
        applianceSelect.addEventListener("change", function () {
            customWattageGroup.style.display = this.value === "custom" ? "block" : "none";
        });

        // 计算按钮事件
        calculateBtn.addEventListener("click", calculateCost);

        // 回车触发计算
        document.getElementById("electricity-usage").addEventListener("keypress", function (e) {
            if (e.key === "Enter") calculateCost();
        });
        document.getElementById("price").addEventListener("keypress", function (e) {
            if (e.key === "Enter") calculateCost();
        });
        document.getElementById("custom-wattage").addEventListener("keypress", function (e) {
            if (e.key === "Enter") calculateCost();
        });

        function calculateCost() {
            // 获取灯具功率
            let wattage;
            if (applianceSelect.value === "custom") {
                wattage = parseFloat(document.getElementById("custom-wattage").value);
                if (isNaN(wattage) || wattage <= 0) {
                    alert("Please enter a valid wattage");
                    return;
                }
            } else {
                wattage = parseFloat(applianceSelect.value);
            }

            // 获取使用时长
            const usageInput = parseFloat(document.getElementById("electricity-usage").value);
            if (isNaN(usageInput) || usageInput < 0) {
                alert("Please enter a valid usage value");
                return;
            }
            const usageUnit = document.getElementById("usage-unit").value;
            const usageHours = usageUnit === "minutes" ? usageInput / 60 : usageInput;

            // 获取电价
            const price = parseFloat(document.getElementById("price").value);
            if (isNaN(price) || price < 0) {
                alert("Please enter a valid electricity price");
                return;
            }

            // 计算能耗与费用
            const kWhPerDay = (wattage * usageHours) / 1000;
            const costPerHour = (wattage / 1000) * price;
            const costPerDay = kWhPerDay * price;
            const costPerMonth = costPerDay * 30;
            const costPerYear = costPerDay * 365;

            // 更新结果
            document.getElementById("cost-hour").textContent = "$" + costPerHour.toFixed(2);
            document.getElementById("cost-day").textContent = "$" + costPerDay.toFixed(2);
            document.getElementById("cost-month").textContent = "$" + costPerMonth.toFixed(2);
            document.getElementById("cost-year").textContent = "$" + costPerYear.toFixed(2);
            document.getElementById("kwh-day").textContent = kWhPerDay.toFixed(2);

            resultsDiv.style.display = "block";
        }

        // ---------- 灯具数量计算器逻辑 ----------
        document.getElementById("calculateButton").addEventListener("click", async function () {
            const length = parseFloat(document.getElementById("lighting-length").value);
            const width = parseFloat(document.getElementById("lighting-width").value);
            const height = parseFloat(document.getElementById("lighting-height").value);
            const lightType = document.getElementById("lightType").value;
            const sceneUsage = document.getElementById("sceneUsage").value;

            // 灯具流明参数表
            const lightLumens = {
                "100-adjustable": 14000,
                "150-adjustable": 21000,
                "200-adjustable": 28000,
                "240-adjustable": 33600,
                "400-adjustable": 60000,
                "150-hb-black": 24000,
                "150-hb-white": 24000,
                "200-hb-black": 32000,
                "200-hb-white": 32000,
                "240-hb-black": 36000,
                "240-hb-white": 36000,
                "300-hb": 42000,
                "100-eco": 11000,
                "150-eco": 16500,
                "150-ufo": 16500,
                "130-linear": 19500,
                "210-linear": 31500,
                "300-linear": 45000,
            };

            // 场景对应目标照度（lux）
            const luxValues = {
                "Bedroom": 130,
                "Living Room": 130,
                "Kitchen": 300,
                "Study": 450,
                "Industrial": 450,
                "Factory": 450,
                "Bathroom": 300,
                "Office Work Area": 300,
                "Conference Room": 300,
                "Reception Area": 200,
                "Retail Stores": 650,
                "Restaurants": 80,
                "Warehouse": 200,
                "General Manufacturing": 300,
                "Fine Work Inspection": 700,
                "Assembly Line": 450,
                "Classrooms": 300,
                "Laboratories": 700,
                "Hospital Wards": 200,
                "Operating Rooms": 1500,
                "Parking Lots": 100,
                "Sidewalks": 130,
                "Sports Fields": 700,
            };

            // 输入校验
            if (isNaN(length) || length <= 0 || isNaN(width) || width <= 0 || isNaN(height) || height <= 0) {
                document.getElementById("lighting-result").innerText = "Please enter valid dimensions.";
                return;
            }

            // 生成专业方案备注文案
            function getProfessionalNote(fixtureCount, ceilingHeight) {
                if (ceilingHeight >= 30 || fixtureCount >= 10) {
                    return `<br><span style="color: #ffd555; font-size: 0.9em; display: block; margin-top: 10px; text-align: left;">
                        💡 For large spaces, high-ceiling facilities or projects with 10+ fixtures, we recommend contacting our lighting design team for free professional DIALux / AGi32 simulations: 
                        <a href="mailto:support@jclgl-led.com" style="color: #ffd555; text-decoration: underline;">support@jclgl-led.com</a>
                       </span>`;
                }
                return `<br><span style="color: rgba(255,255,255,0.8); font-size: 0.85em; display: block; margin-top: 8px;">
                    * Estimated value for reference only. For custom project design, feel free to contact our professional team.
                   </span>`;
            }

            // 高度修正因子（按英尺区间匹配）
            function getHeightCorrectionFactor(heightFt) {
                if (heightFt < 10) return 1.0;
                if (heightFt >= 10 && heightFt < 15) return 1.1;
                if (heightFt >= 15 && heightFt < 20) return 1.2;
                if (heightFt >= 20 && heightFt < 25) return 1.3;
                if (heightFt >= 25 && heightFt < 30) return 1.4;
                if (heightFt >= 30 && heightFt < 35) return 1.5;
                if (heightFt >= 35 && heightFt < 40) return 1.6;
                if (heightFt >= 40 && heightFt < 45) return 1.7;
                return 1.8; // 45ft 及以上超高空间
            }

            // 统一灯具数量计算（核心修复：场景照度生效）
            function calcFixtureCount() {
                const areaSqFt = length * width;
                // 读取场景照度，兜底默认200lux
                const targetLux = luxValues[sceneUsage] || 200;
                const lumensPerFixture = lightLumens[lightType] || 20000;
                // 单位转换 + 维护系数（1.2，考虑光衰、灰尘、环境损耗）
                const totalLumensRequired = areaSqFt * targetLux * 0.0929 * 1.2;
                const correctionFactor = getHeightCorrectionFactor(height);
                return Math.ceil((totalLumensRequired / lumensPerFixture) * correctionFactor);
            }

            const lightsNeeded = calcFixtureCount();

            try {
                // 调用API获取布局数据
                const apiUrl = `https://stock.romanso-led.com/api/lights/calculate?length=${length}&width=${width}&height=${height}`;
                const response = await fetch(apiUrl);

                if (!response.ok) {
                    throw new Error(`API request failed with status ${response.status}`);
                }

                const result = await response.json();
                if (!result.success || !result.data) {
                    throw new Error("API returned invalid data");
                }

                // 解析API返回的布局数据
                const layoutStr = result.data.layout;
                const spacingStr = result.data.spacing;
                const scale = result.data.scale || 5;
                const layout = layoutStr.split('x').map(num => parseInt(num.trim()));
                const spacing = spacingStr.split('x').map(num => parseFloat(num.trim()));
                const apiLayoutInfo = `Layout: ${result.data.layout} <br> Spacing: ${result.data.spacing} ft <br> ${result.data.suggestion}`;

                // 渲染布局图
                const layoutContainer = document.getElementById('layout-container');
                const containerWidth = layout[0] * spacing[0] * scale;
                const containerHeight = layout[1] * spacing[1] * scale;
                layoutContainer.style.width = `${containerWidth}px`;
                layoutContainer.style.height = `${containerHeight}px`;
                layoutContainer.innerHTML = '';

                // 绘制灯具点位
                for (let i = 0; i < layout[0]; i++) {
                    for (let j = 0; j < layout[1]; j++) {
                        const point = document.createElement('div');
                        point.className = 'light-point';
                        const x = (i + 0.5) * spacing[0] * scale;
                        const y = (j + 0.5) * spacing[1] * scale;
                        point.style.left = `${x}px`;
                        point.style.top = `${y}px`;
                        layoutContainer.appendChild(point);
                    }
                }

                // 添加尺寸标签
                addLabel(layoutContainer, spacing[0] * scale, 0, spacing[0].toFixed(2), false, true);
                addLabel(layoutContainer, 0, spacing[1] * scale, spacing[1].toFixed(2), true);

                function addLabel(container, x, y, text, vertical = false, horizontal = false) {
                    const label = document.createElement('div');
                    label.className = 'layout-label';
                    label.textContent = text;
                    if (vertical) {
                        label.style.left = `${x}px`;
                        label.style.top = `${y}px`;
                    } else if (horizontal) {
                        label.style.left = `${x - 10}px`;
                        label.style.top = `${y}px`;
                    }
                    container.appendChild(label);
                }

                // 显示结果：使用基于场景照度计算的灯具数量 + API布局参考
                document.getElementById("lighting-result").innerHTML =
                    `Number of fixtures needed: <strong>${lightsNeeded}</strong><br>` +
                    apiLayoutInfo +
                    getProfessionalNote(lightsNeeded, height);

            } catch (error) {
                console.error("API layout fetch failed, showing count only:", error);

                // 备用：仅显示计算结果，无布局图
                document.getElementById("lighting-result").innerHTML =
                    `Number of fixtures needed: <strong>${lightsNeeded}</strong><br>` +
                    `<span style="color: rgba(255,255,255,0.8); font-size: 0.9em;">(Estimated reference value)</span>` +
                    getProfessionalNote(lightsNeeded, height);
            }

            // 显示产品跳转按钮
            const productLinkButton = document.getElementById("productLinkButton");
            productLinkButton.style.display = "block";

            // 产品链接映射
            const productLinks = {
                "100-adjustable": "https://jclgl-led.com/products/jc-lgl-high-bay-led-light-adjustable-series?variant=44279129637084",
                "150-adjustable": "https://jclgl-led.com/products/jc-lgl-high-bay-led-light-adjustable-series?variant=44279129669852",
                "200-adjustable": "https://jclgl-led.com/products/jc-lgl-high-bay-led-light-adjustable-series?variant=44279129702620",
                "240-adjustable": "https://jclgl-led.com/products/jc-lgl-high-bay-led-light-adjustable-series?variant=45268968734940",
                "400-adjustable": "https://jclgl-led.com/products/jc-lgl-high-bay-led-light-adjustable-series?variant=45517602128092",
                "150-hb-black": "https://jclgl-led.com/products/jc-lgl-led-high-bay-light-hb-series-black?variant=45117068869852",
                "200-hb-black": "https://jclgl-led.com/products/jc-lgl-led-high-bay-light-hb-series-black?variant=45117068935388",
                "240-hb-black": "https://jclgl-led.com/products/jc-lgl-led-high-bay-light-hb-series-black?variant=45117069000924",
                "300-hb": "https://jclgl-led.com/products/jc-lgl-led-high-bay-light-hb-series-black?variant=45117069066460",
                "150-hb-white": "https://jclgl-led.com/products/jc-lgl-led-high-bay-light-hb-series-white-with-adjustable-1",
                "200-hb-white": "https://jclgl-led.com/products/jc-lgl-led-high-bay-light-hb-series-white-with-adjustable-1",
                "240-hb-white": "https://jclgl-led.com/products/jc-lgl-led-high-bay-light-hb-series-white-with-adjustable-1",
                "130-linear": "https://jclgl-led.com/products/jc-lgl-led-linear-high-bay-shop-light?variant=45269885092060",
                "210-linear": "https://jclgl-led.com/products/jc-lgl-led-linear-high-bay-shop-light?variant=45269885026524",
                "300-linear": "https://jclgl-led.com/products/jc-lgl-led-linear-high-bay-shop-light?variant=45269884960988"
            };

            if (productLinks[lightType]) {
                productLinkButton.onclick = function () {
                    window.location.href = productLinks[lightType];
                };
            }
        });
    });